import { z } from "zod";
/**
 * Shared chat contract types.
 *
 * These types are the single source of truth for the request/response
 * protocol between the frontend SSE client and the Lambda chat handler.
 */
// ── Request ──────────────────────────────────────────────────────────
export const chatMessageSchema = z.object({
    role: z.enum(["user", "assistant"]),
    content: z.string().min(1),
});
export const chatRequestBodySchema = z.object({
    /** The current user message */
    message: z.string().min(1),
    /** Previous conversation turns */
    conversationHistory: z.array(chatMessageSchema).optional(),
});
// ── SSE Response ─────────────────────────────────────────────────────
export const sseEventTypeSchema = z.enum([
    "text",
    "tool_start",
    "tool_end",
    "error",
    "done",
]);
export const sseEventSchema = z.object({
    type: sseEventTypeSchema,
    data: z.string().optional(),
    toolName: z.string().optional(),
});
/** Sentinel value that signals end of SSE stream */
export const SSE_DONE_SENTINEL = "[DONE]";
//# sourceMappingURL=chat.js.map